import { render, staticRenderFns } from "./Barcode.vue?vue&type=template&id=f0d9b5fe&"
import script from "./Barcode.vue?vue&type=script&lang=js&"
export * from "./Barcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports